import { Component, Inject, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-selection',
  templateUrl: './selection.component.html',
  styleUrls: ['./selection.component.css']
})
export class SelectionComponent implements OnInit {

  accs = [{
    email: '',
    flag: true,
    needCreate: false,
    userAcc: false,
    userId: null,
  },
  {
    email: '',
    flag: true,
    needCreate: false,
    userAcc: false,
    userId: null,
  }];
  existingEmail = [];
  existingUserEmail = [];
  selected: string = '';
  email: string;
  constructor(
    public dialogRef: MatDialogRef<SelectionComponent>,
    private firestore: AngularFirestore,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private toast: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.email = data.CreatedBy;
    if (data.Assigned) {
      for (let index = 0; index < data.Assigned.length; index++) {
        const element = data.Assigned[index];
        if (index >= this.accs.length) {
          this.accs.push({
            email: element,
            flag: true,
            needCreate: false,
            userAcc: false,
            userId: null
          })
        } else {
          this.accs[index].email = element;
        }
      }
    }
  }

  ngOnInit() {
    this.spinner.show();
    this.existingEmail = [];
    this.existingUserEmail = [];

    this.firestore.collection("Admin", ref => ref.where('Role', '==', 'Admin').orderBy('Email', 'asc')).get().forEach(async e => {
      e.forEach(ed => {
        if (ed.exists) {
          this.existingEmail.push({ id: ed.id, email: ed.data().Email })
        }
      })
    })

    this.firestore.collection("Users").get().forEach(async e => {
      e.forEach(ed => {
        if (ed.exists) {
          this.existingUserEmail.push({ id: ed.id, email: ed.data().Email })
        }
      })
    })

    setTimeout(() => {
      this.spinner.hide();

    }, 500);

  }

  close(): void {
    this.dialogRef.close();
  }

  add() {
    this.accs.push({ email: '', flag: true, needCreate: false , userAcc: false, userId: null})
  }

  delete(index) {
    this.accs.splice(index, 1)
  }
  select() {
    if (this.accs.find(e => !e.email || !e.flag)) {
      this.toast.error("Invalid email");
      return;
    }

    if (this.accs.find(e => e.email === this.email)) {
      this.toast.error("Cannot assign email as same as applicant's email");
      return;
    }

    for (const acc of this.accs) {
      let useracc = this.existingUserEmail.find(e => e.email === acc.email);
      if(useracc){
        acc.userAcc = useracc.email;
        acc.userId = useracc.id;
      }
      else
        acc.needCreate = this.existingEmail.find(e => e.email === acc.email) ? false : true;
    }

    const duplicates = this.accs.filter((item, index) => this.accs.findIndex(e => e.email === item.email) !== index);
    if (duplicates.length > 0) {
      this.toast.error("Duplicate email");
      return;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.height = 'auto';
    dialogConfig.width = '30%';

    const position = { top: '10%' };
    dialogConfig.position = position;
    dialogConfig.disableClose = true;
    dialogConfig.data = 'Confirm?';

    this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(async data => {
      if (data) {
        this.dialogRef.close(this.accs)
      }
    })
  }


  validateEmail(value, index) {
    if ((/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(.[a-zA-Z0-9-]+)*$/.test(value))) {
      this.accs[index].flag = true;
    } else {
      this.accs[index].flag = false;
    }
  }


}
